// src/firebase/config.js
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: "https://appcenter-cd3a5-default-rtdb.firebaseio.com",
};

// Initialize Firebase only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Only auth + firestore load eagerly. RTDB (@firebase/database) must NEVER be
// statically imported from the main graph — it added ~630KB of source to the
// boot bundle. Lazy consumers use `import("firebase/database")` + getDatabase().
export const auth = getAuth(app);
export const db = getFirestore(app);

console.log("Firebase initialized");

export default app;
